import { MenuItem } from '@bea-shell/common/objects';

export class TopbarOptions {
    left?: MenuItem[]
    right?: MenuItem[]
    disabled?: boolean
}